import React from 'react';

// Create a new context for modal functionality
const ModalContext = /*#__PURE__*/React.createContext({
  onHide: () => {}
});
export default ModalContext;